window.addEventListener("scroll", function() {
    if (window.scrollY > 1500 && window.scrollY < 3500) {
        $('.fixedDiv').css('display', 'block').animate({opacity: 1}, 1); // Fade in
    } else {
        $('.fixedDiv').css('display', 'block').animate({opacity: 0}, 1); // Fade out
    }
}, false);

